import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { CustomerSupportRepository } from '../repositories/customer-support.repository';
import { ContactFormRequest } from '../models/ContactFormRequest.model';
import { ContactFormResponse } from '../models/ContactFormResponse.model';

export class SendFormUseCase
    implements UseCase<ContactFormRequest, ContactFormResponse>
{
    constructor(private readonly repository: CustomerSupportRepository) {}

    execute(
        sendFormRequest: ContactFormRequest,
    ): Observable<ContactFormResponse> {
        return this.repository.sendForm(sendFormRequest);
    }
}
